// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"S1-z","colorTextValue":"T1-z","swatches":"U1-z","collapseLink":"V1-z","isCollapsed":"W1-z","dropdown":"X1-z","disabled":"Y1-z"};